import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["ballCount", "targetSize", "targetWidth", "targetLength", "refFlour", "refSize", "refWidth", "refLength", "ingredientRow", "totalBallWeight", "totalBatchWeight", "shapeField"]
    static values = { shape: String }

    connect() {
        console.log("Calculator Connected")
        this.toggleInputs()
        this.calculate()
    }

    toggleInputs() {
        // Find the radio buttons or hidden field for shape
        const shape = this.getShape()
        console.log("Toggling Inputs. Shape:", shape)
        // Scope searches to this.element to avoid conflicts between Form and Show page
        const circleInputs = this.element.querySelectorAll('.calc-circle-input')
        const rectInputs = this.element.querySelectorAll('.calc-rect-input')

        if (shape === 'rectangle') {
            circleInputs.forEach(el => el.classList.add('hidden'))
            rectInputs.forEach(el => el.classList.remove('hidden'))
        } else {
            circleInputs.forEach(el => el.classList.remove('hidden'))
            rectInputs.forEach(el => el.classList.add('hidden'))
        }
    }

    getShape() {
        // Check for radio buttons within this controller's scope first
        const checkedRadio = this.element.querySelector('input[name="recipe[shape]"]:checked')
        if (checkedRadio) return checkedRadio.value

        // Fallback to data-value (in view mode or if no radio found)
        return this.shapeValue || 'circle'
    }

    calculate() {
        const shape = this.getShape()
        const balls = parseFloat(this.ballCountTarget.value) || 1
        const refFlour = parseFloat(this.refFlourTarget.value) || 250

        let sizeRatio = 1

        if (shape === 'rectangle') {
            const targetW = parseFloat(this.targetWidthTarget.value) || 0
            const targetL = parseFloat(this.targetLengthTarget.value) || 0
            const refW = parseFloat(this.refWidthTarget.value) || 0
            const refL = parseFloat(this.refLengthTarget.value) || 0

            if (targetW > 0 && targetL > 0 && refW > 0 && refL > 0) {
                const targetArea = targetW * targetL
                const refArea = refW * refL
                sizeRatio = targetArea / refArea
            }
        } else {
            // Circle Default
            const targetSize = parseFloat(this.targetSizeTarget.value) || 12
            const refSize = parseFloat(this.refSizeTarget.value) || 14

            // Area Ratio = (TargetDiameter / RefDiameter)^2
            if (targetSize > 0 && refSize > 0) {
                sizeRatio = Math.pow(targetSize / refSize, 2)
            }
        }

        // Flour needed per ball = Reference Flour * Size Ratio
        const flourPerBall = refFlour * sizeRatio

        // Total Flour for Batch
        const totalFlour = flourPerBall * balls

        let totalBatchWeight = 0

        this.ingredientRowTargets.forEach(row => {
            const percentage = parseFloat(row.dataset.percentage)
            // weight = TotalFlour * (Percentage / 100)
            const weight = totalFlour * (percentage / 100)

            totalBatchWeight += weight

            let displayWeight
            if (weight < 1) {
                displayWeight = weight.toFixed(2)
            } else if (weight < 10) {
                displayWeight = weight.toFixed(1)
            } else {
                displayWeight = Math.round(weight)
            }

            row.querySelector(".ingredient-weight").innerText = `${displayWeight}g`
        })

        this.totalBatchWeightTarget.innerText = `${Math.round(totalBatchWeight)}g`
        this.totalBallWeightTarget.innerText = `${Math.round(totalBatchWeight / balls)}g`
    }
}
